<!--
 * @Author: katty 15032801667@163.com
 * @Date: 2023-01-10 15:39:16
 * @LastEditors: katty 15032801667@163.com
 * @LastEditTime: 2023-01-31 16:12:40
 * @FilePath: \epec-ea\src\modules\projectA\pages\pay\accountManagement.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="container">
    <div class="content-wrapper" v-if="isInCpcnWhite === 1">
      <div class="content-top">
        <div class="top-left handle-column">
              <div class="company-name">{{ accountList.companyName }}</div>
            <eui-tooltip :content="'企业信息审核拒绝，'+ accountList.feedBack" placement="right"
                         v-if="accountList.feedBack">
                <div class="flex-all-center">
                  <div style="font-size: 14px;">审核拒绝</div>
                  <eui-icon class="data-icon" icon="eicon-r-changjianwenti"  font-size="16px"/>
                </div>
              </eui-tooltip>
               <div class="container-btn" @click="handleGo">管理信息</div>
        </div>
        <div class="top-bottom handle-column">
            <div class="part-1-1 ">
              账户余额
              <el-tooltip class="left-icon" effect="dark" placement="top">
                <div slot="content">
                  <p>
                    您可能仍存尚未完成的交易，部
                    <br />
                    分款项仍在冻结中，待交易完成
                    <br />
                    后系统会自动解冻相应货款。
                  </p>
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div class="part-1-2" style="color: #333333;">
              (可用￥{{ Number(accountList.balance) / 100}},冻结￥{{ Number(accountList.frozenAmount) / 100 }})
            </div>
          <div class="handle-column">
            <el-button type="primary" @click="handleWithdraw" class="margin-t10">提现</el-button>
           </div>
        </div>
      </div>
      <div class="content-bottom">
        <div class="bottom-box handle-column">
          <div class="part-1">
            <div class="part-1-1">已绑定银行卡{{ cardNumber }}张</div>
            <div class="part-1-2" @click="handleManage(accountList.id)">管理</div>
          </div>
        </div>
        <div class="bottom-box handle-column">
          <div class="part-1">
            <div class="part-1-1">{{accountList.paymentPermission !== '20' ? '收款权限未开通' :'收款权限已开通'}}</div>
            <div class="part-1-2" v-if="accountList.paymentPermission !== '20'" @click="toOpen">申请开通</div>
           </div>
        </div>
        <div class="bottom-box handle-column">
          <div class="part-1">
          <!--  开关标志 0、开启 1、关闭-->
            <div class="part-1-1">{{wechatSwitchFlag === 1 ? '微信收款未开通' :'微信收款已开通'}}</div>
            <div class="part-1-2" @click="initiateAuthorization()"
                 v-if="wechatSwitchFlag === 1 && (wechatStatus === '30' || wechatStatus === '40' || wechatStatus === '20' )">
              申请实名认证
            </div>
            <div v-else>
              <div class="part-1-2" @click="handleOpen" v-if="wechatSwitchFlag">申请开通</div>
            </div>
          </div>
        </div>
        <div class="bottom-box handle-column">
          <div class="part-1">
            <!--  开关标志 0、开启 1、关闭-->
            <div class="part-1-1">{{alipaySwitchFlag === 1 ? '支付宝收款未开通' :'支付宝收款已开通' }}</div>
            <div class="part-1-2" @click="initiateAuthorization()"
                 v-if="alipaySwitchFlag === 1 && (alipayStatus === '30' || alipayStatus === '40' || alipayStatus === '20')">
              申请实名认证
            </div>
            <div v-else>
              <div class="part-1-2" @click="handleOpen" v-if="alipaySwitchFlag">申请开通</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <no-permission  v-if="isInCpcnWhite === 2"/>
    <el-dialog
            title="提现"
            :visible.sync="visible"
            width="420px"
            :append-to-body="true"
            @close="handleClose"
    >
      <el-form
              :model="form"
              :rules="rules"
              ref="form"
              :label-position="'right'"
              label-width="110px"
              class="form"
      >
        <el-form-item label="提现至银行卡:" prop="serialNo">
          <el-select
                  style="width: 200px"
                  v-model="form.serialNo"
                  placeholder="请选择"
                  @change="selectChange"
          >
            <el-option
                    v-for="item in bankCardList"
                    :key="item.bankCardNo"
                    :label="item.bankCardNo + item.bankName"
                    :value="item.serialNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现金额:" prop="amount">
          <el-input
                  style="width: 200px"
                  v-model.trim="form.amount"
                  placeholder="请输入提现金额"
                  @input="limitInput($event,'amount')"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="footer-dialog">
        <div class="cancel-btn" @click="handleClose">取消</div>
        <div class="submit-btn" @click="handleSubmit">完成</div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import api from "../../api/pay/index";
import orderApi from "../../api/order";
import {epecMallUrl} from '../../api/config';
import noPermission from '../../components/pay/noPermission';
export default {
  name: "EpecEaAccountManagement",
  components: {
    noPermission
  },
  data() {
    return {
      wechatSwitchFlag:'',
      wechatStatus:'',
      alipaySwitchFlag:'',
      alipayStatus:'',
      accountList: {
        paymentPermission:'20'
      },
      cardNumber: 0,
      availableBalance: "",
      frozenBalance: "",
      visible: false,
      form: {
        serialNo: "",
        amount: "",
      },
      rules: {
        serialNo: [{ required: true, message: "请选择银行卡", trigger: "blur" }],
        amount: [{ required: true, message: "请输入提现金额", trigger: "blur" }],
      },
      bankCardList: [],
      isInCpcnWhite:3,//1 是有白名单，2是没有
    };
  },

  mounted() {
    this.isInCpcnWhiteList();
  },

  methods: {
    //发起授权
    initiateAuthorization(){
      this.$router.push({ path: "/scanCodePayManagement"})
    },
   async isInCpcnWhiteList(){
      let res = await api.isInCpcnWhiteList();
      if (res.success) {
          if(res.data){
            this.isInCpcnWhite = 1;
            this.getAccountList();
            this.getBankCardList();
          }else{
            this.isInCpcnWhite = 2;
          }
      }
    },
    queryBothAuthority() {
      this.queryScanCodeApplyStatus('wechat');
      setTimeout(() => {
        this.queryScanCodeApplyStatus('alipay');
      }, 10)
    },
    async queryScanCodeApplyStatus(type) {
      let params = {
        companyId: this.accountList.companyId,
        payWay: type === 'wechat'? 10 :20,
      }
      let res = await orderApi.queryScanCodeApplyStatus(params);
      if (res.code === "200") {
        //开关标志 0、开启 1、关闭
        if (type === 'wechat') {
          this.wechatSwitchFlag = res.data.switchFlag;
          this.wechatStatus = res.data.applyStatus;
         } else {
          this.alipaySwitchFlag = res.data.switchFlag;
          this.alipayStatus = res.data.applyStatus;
        }
      }
    },
    toOpen(){
       window.open(`${epecMallUrl}/chinaPayment/register?step=4&status=${this.accountList.paymentPermission}`, '_blank')
    },
    handleOpen(){
      this.$router.push({path: "/scanCodePayManagement",});
    },
    limitInput(value, name) {
            this.form[name] =
                ("" + value) // 第一步：转成字符串
                .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
                .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
                .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
                .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
            },
    async getAccountList() {
      let res = await api.getAccountList();

      if (res.code == "200") {
        this.accountList = res.data;
        this.queryBothAuthority();//判断微信、支付宝是否开通
      }
    },
    async getBankCardList() {
      let res = await api.queryAvailableBankCard();

      if (res.code == "200") {
        this.bankCardList = res.data;
        this.cardNumber = res.data.length;
      }
    },
    handleManage(id) {
      this.$router.push({
        path: "/bankCardManagement",
        query: { payAccountId: id },
      });
    },
    handleWithdraw() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.$refs.form.resetFields();
    },
    selectChange() {},
    async handleSubmit() {
      let params = {
        bindingTxSN: this.form.serialNo,
        amount: this.form.amount,
      };
      let res = await api.withdrawCash(params);

      if (res.code == "200") {
        this.$message({
          type: "info",
          message: "提现成功",
        });
        this.visible = false
        this.$refs.form.resetFields();
      }
    },
    handleGo() {
      this.$router.push({
        path: "/cpcnAccount",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .content-wrapper {
    width: 100%;
    height: 228px;
    border: 1px solid #D9D9D9;
    .handle-column{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .content-top {
      padding: 14px;
      display: flex;
      height: 122px;
      .top-left {
        flex: 1;
        border-right: 1px solid #D9D9D9;
        .company-name{
          font-size: 16px;
          margin-bottom: 10px;
        }
        .container-btn {
          font-size: 14px;
          color: #0064c8;
          cursor: pointer;
        }
      }

      .top-bottom {
        flex: 1;
      }
    }
    .content-bottom{
      display: flex;
      height: 106px;
      border-top: 1px solid #D9D9D9;
     padding: 20px;
      .bottom-box{
        flex: 1;
        border-right: 1px solid #D9D9D9;
        &:last-child{
          border-right: none;
        }
        .part-1 {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .part-1-1 {
            font-size: 14px;
            color: #333333;
            margin-bottom: 10px;
            position: relative;
            font-weight: 700;
            .left-icon {
              position: absolute;
              left: 60px;
              top: 2px;
              width: 18px;
              height: 18px;
              line-height: 16px;
              text-align: center;
              border-radius: 50%;
              border: 1px solid #c5c5c5;
              font-size: 12px;
              color: #c5c5c5;
              cursor: pointer;
              &:hover {
                background: #c5c5c5;
                color: #fff;
              }
            }
          }
          .part-1-2 {
            font-size: 14px;
            color: #0064c8;
            cursor: pointer;
          }
          .part-btn {
            width: 80px;
            height: 30px;
            background: #2587ff;
            cursor: pointer;
            font-size: 14px;
            line-height: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 30px;
          }
        }
      }
    }

  }
.container-header {
  display: flex;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 10px;
  align-items: center;
  .container-companyName {
    font-size: 16px;
    color: #333333;
    margin-right: 10px;
  }
  .container-btn {
    font-size: 14px;
    color: #0064c8;
    cursor: pointer;
  }
}
.container-body {
  /* padding: 20px; */
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  .part-1 {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .part-1-1 {
      font-size: 14px;
      color: #333333;
      margin-bottom: 10px;
      position: relative;
      font-weight: 700;
      .left-icon {
        position: absolute;
        left: 60px;
        top: 2px;
        width: 18px;
        height: 18px;
        line-height: 16px;
        text-align: center;
        border-radius: 50%;
        border: 1px solid #c5c5c5;
        font-size: 12px;
        color: #c5c5c5;
        cursor: pointer;
        &:hover {
          background: #c5c5c5;
          color: #fff;
        }
      }
    }
    .part-1-2 {
      font-size: 14px;
      color: #0064c8;
      cursor: pointer;
    }
    .part-btn {
      width: 80px;
      height: 30px;
      background: #2587ff;
      cursor: pointer;
      font-size: 14px;
      line-height: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
    }
  }
  .line {
    width: 0;
    height: 100%;
    border-left: 1px solid #d9d9d9;
  }
}
.footer-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  .submit-btn {
    width: 80px;
    height: 30px;
    background: #2587ff;
    font-size: 14px;
    color: #ffffff;
    line-height: 30px;
    cursor: pointer;

    text-align: center;
  }
  .cancel-btn {
    border: 1px solid #2587ff;
    width: 80px;
    height: 30px;
    background: #ffffff;
    font-size: 14px;
    color: #2587ff;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    margin-right: 20px;
  }
}
.form {
        margin: 0 auto;
        ::v-deep .el-input__inner{
            border-radius: 0;
        }
   
    }
</style>
